import React from "react";

const ResumeTitle = ({ icon, title }) => {
  return (
    <div className="flex items-center gap-3 pb-4 mb-4 border-b border-gray-700">
      <span className="text-2xl text-blue-400">{icon}</span>
      <h1 className="text-xl font-semibold text-gray-300 uppercase tracking-wider">
        {title}
      </h1>
    </div>
  );
};

export default ResumeTitle;